/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/prop-types */

import { Button, DatePicker, Form, Row, Space, Tooltip } from "antd";
import { TimePicker } from "antd-v5";

import EditOrViewCell from "../EditOrViewCell/EditOrViewCell";
import { QuestionCircleOutlined } from "@ant-design/icons";
import React, { useMemo } from "react";
import Sorter from "../Sorter";
import dayjs from "dayjs";
import s from "./exhibition-table-row.module.less";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useOnlyLatinLetterInputHandlerAndModal from "../../../hooks/useOnlyLatinLetterInputHandlerAndModal";
import SecondaryTableRow from "../SecondaryTableRow/SecondaryTableRow";
import Item from "antd/lib/list/Item";
import { convertDate, convertTime } from "../../../helpers/timeFormat";
import { setExhibitionInitialValues, setSavedExhibition } from "../../../store/exhibitionSlice";
import { useDispatch } from "react-redux";
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
const statusColor = {
  1: "#f32d2d",
  2: "black",
  3: "#249f5d",
  4: "#f32d2d",
  5: "#f32d2d"
};

const ExhibitionTableRow = ({
  item,
  handleOpenModal,
  sorting,
  handleSort,
  setStandInfo,
  isFirstElement,
  /* form, */
  setPassageDiagram,
  handleErrors,
  clearImage,
  passageDiagram,
  isAdmin,
  setCurrentItem,
  setExhibitionForDelete,
  isArchive,
  onFinish,
  setIsImageDeleted,
  errors,
  setErrors,
  editindExhibition,
  isImageDeleted,
  handleEdit,
  editingStand,
  isUserExhibition
}) => {
  const { cities } = useSelector((state) => state.resources);
  const { lang } = useSelector((state) => state.auth);
  const {
    editExhibitionId,
    savedExhibition,
    editStandId,
    exhibitionPanel,
    editOnlyStand,
    exhibitionInitialValues
  } = useSelector((state) => state.exhibitions);
  const dispatch = useDispatch();
  const [logo, setLogo] = useState("");
  const [isLogoDeleted, setIsLogoDeleted] = useState(false);
  const [form] = Form.useForm();
  const stand = useMemo(() => item?.stands?.find((stand) => stand.id == editStandId), [item]);
  const initialCheckbox = {
    isPrivate: item.isPrivate,
    isVisible: stand?.isVisible || false
  };
  const [checkBoxSelected, setCheckboxSelected] = useState(initialCheckbox);
  const allValues = Form.useWatch([], form);
  const { t } = useTranslation([
    "BA1-EditAndViewExhibition",
    "CreateExhibitionPanel",
    "FS8-changeCompanyProfile",
    "FS100-MyExhibitions"
  ]);
  const { isEditMode } = useSelector((state) => state.exhibitions);
  const isExhibitionEditable = editExhibitionId === item.id;
  const { pathname } = useLocation();

  const isEditIconShow =
    editExhibitionId === item.id
      ? isEditMode && (editExhibitionId === item.id || editStandId === stand?.id)
      : false;

  const [times, setTimes] = useState({
    endDate: "",
    startDate: "",
    times: []
  });
  const navigate = useNavigate();

  const moderationStatusObject = {
    1: t("platformEdited", { ns: "FS100-MyExhibitions" }),
    2: t("edited", { ns: "FS100-MyExhibitions" }),
    3: t("moderated", { ns: "FS100-MyExhibitions" }),
    4: t("moderationRejected", { ns: "FS100-MyExhibitions" }),
    5: t("platformEdited", { ns: "FS100-MyExhibitions" })
  };

  const restoreData = async () => {
    onFinish(
      {
        ...savedExhibition.exhibition,
        item: savedExhibition.item,
        exhibition: savedExhibition?.exhibition.exhibition,
        onSuccess: () => {
          setPassageDiagram(savedExhibition.exhibition.passageDiagram);
          setLogo(savedExhibition.exhibition.logo);
          dispatch(setSavedExhibition(null));
        },
        onError: () => {
          dispatch(setSavedExhibition(null));
        }
      },
      savedExhibition.times
    );
  };

  useEffect(() => {
    console.log(savedExhibition);
    if (!savedExhibition || !isExhibitionEditable || savedExhibition?.isCreating) return;
    restoreData();
  }, [savedExhibition]);

  useEffect(() => {
    if (!isArchive && item.startDate && item.endDate) {
      setTimes((prev) => ({
        ...prev,
        startDate: dayjs(dayjs(item.startDate).format(dateFormat)),
        endDate: dayjs(dayjs(item.endDate).format(dateFormat)),
        times: calcDaysWorkingTimeArr(item.startDate, item.endDate, item.times)
      }));
      item.times.forEach((_, i) => {
        form.setFieldsValue({
          [`rangePicker_${i}`]: [
            dayjs(dayjs(times.startDate || item.startDate?.$d).format("YYYY-MM-DD 10:00")),
            dayjs(dayjs(times.endDate || item.endDate?.$d).format("YYYY-MM-DD 18:00"))
          ]
        });
      });
    }

    if (isArchive) {
      setTimes((prev) => ({
        ...prev,
        startDate: dayjs(dayjs(item.startDate).format(dateFormat)),
        endDate: dayjs(dayjs(item.endDate).format(dateFormat)),
        times: calcDaysWorkingTimeArr(item.startDate, item.endDate, item.times)
      }));
    }
  }, [item, isEditMode]);

  const onWorkingTimeChange = (val, index) => {
    setTimes((prev) => {
      return {
        ...prev,
        times: prev.times?.map((el, i) => {
          if (i === index) {
            return {
              ...el,
              startDate: prev.startDate,
              endDate: prev.endDate,
              startTime: val?.[0] ? val[0].format("HH:mm") : undefined,
              endTime: val?.[1] ? val[1].format("HH:mm") : undefined,
              timeRange: val
            };
          } else {
            return el;
          }
        })
      };
    });
  };

  const calcDaysWorkingTimeArr = (startDate, endDate, curTimesArr) => {
    if (!startDate || !endDate) return [];
    const date1 = dayjs(startDate);
    const date2 = dayjs(endDate);
    const daysCount = date2.diff(date1, "day");
    const defaultTimeObj = {
      startTime: undefined,
      endTime: undefined,
      date: undefined,
      timeRange: [undefined, undefined]
    };
    const newTimesArr = Array.from({ length: daysCount + 1 }, (_, i) => {
      return {
        ...defaultTimeObj,
        date: date1.add(i, "day").format("DD.MM"),
        timeRange: [
          dayjs(dayjs().format("YYYY-MM-DD 10:00")),
          dayjs(dayjs().format("YYYY-MM-DD 18:00"))
        ]
      };
    });
    if (!isArchive) {
      newTimesArr.forEach((_, i) => {
        form.setFieldsValue({
          [`rangePicker_${i}`]: [
            dayjs(dayjs().format("YYYY-MM-DD 10:00")),
            dayjs(dayjs().format("YYYY-MM-DD 18:00"))
          ]
        });
      });
    }
    curTimesArr.forEach((el, i) => {
      if (i < newTimesArr.length) {
        newTimesArr[i] = {
          ...newTimesArr[i],
          startTime: el.startTime || "10:00",
          endTime: el.endTime || "18:00",
          timeRange: [
            dayjs(dayjs().format("YYYY-MM-DD 10:00")),
            dayjs(dayjs().format("YYYY-MM-DD 18:00"))
          ]
        };
      }
    });
    return newTimesArr;
  };

  const onEndDateChange = (val) => {
    const date = val ? dayjs(val.$d).format(dateFormat) : undefined;
    setTimes((prev) => ({
      ...prev,
      endDate: date,
      times: calcDaysWorkingTimeArr(prev.startDate, date, prev.times)
    }));
  };

  const onStartDateChange = (val) => {
    const date = val[0] ? dayjs(val[0].$d).format(dateFormat) : undefined;
    const endDate = val[1] ? dayjs(val[1].$d).format(dateFormat) : undefined;
    setTimes((prev) => {
      return {
        ...prev,
        startDate: date ? date : prev.startDate,
        endDate: endDate ? endDate : prev.endDate,
        times: calcDaysWorkingTimeArr(
          date ? date : prev.startDate,
          endDate ? endDate : prev.endDate,
          prev.times
        )
      };
    });
  };
  const handleSetValues = () => {
    console.log(editindExhibition);
    if (!isArchive) {
      form.setFieldsValue({
        exhibitionName: editindExhibition?.exhibitionName,
        website: editindExhibition?.website,
        cityId: editindExhibition?.cityId,
        areaName: editindExhibition?.areaName,
        id: editindExhibition?.id,
        logo: editindExhibition?.logo,
        exhibition: {
          countryId: editindExhibition?.country?.id,
          startDate: [dayjs(editindExhibition?.startDate), dayjs(editindExhibition?.endDate)],
          isPrivate: editindExhibition?.isPrivate
        },
        boothNumber: editingStand?.boothNumber,
        description: editingStand?.description || editindExhibition?.description,
        stand: {
          passageDiagram: editingStand?.passageDiagram,
          isVisible: editingStand?.isVisible
        }
      });
      dispatch(
        setExhibitionInitialValues({
          exhibitionName: editindExhibition?.exhibitionName,
          website: editindExhibition?.website,
          id: editindExhibition?.id,
          cityId: editindExhibition?.cityId,
          logo: editindExhibition?.logo,
          areaName: editindExhibition?.areaName,
          exhibition: {
            countryId: editindExhibition?.country?.id,
            startDate: [dayjs(editindExhibition?.startDate), dayjs(editindExhibition?.startDate)],
            isPrivate: editindExhibition?.isPrivate
          },
          boothNumber: editingStand?.boothNumber,
          description: editingStand?.description || editindExhibition?.description,
          stand: {
            passageDiagram: editingStand?.passageDiagram,
            isVisible: editingStand?.isVisible
          }
        })
      );
    }
  };
  useEffect(() => {
    if (editExhibitionId == item.id) handleSetValues();
  }, [form, editExhibitionId, editindExhibition]);

  useEffect(() => {
    if (!isArchive || pathname.includes("/admin-panel/users-list")) {
      form.setFieldsValue({
        boothNumber: editingStand?.boothNumber,
        description: editingStand?.description,
        stand: {
          passageDiagram: editingStand?.passageDiagram,
          isVisible: editingStand?.isVisible
        }
      });
    }
  }, [editingStand, isEditMode]);

  const handleDelete = (stand, exhibition) => {
    if (isAdmin) {
      handleOpenModal("DELETE_MODE");
      const previewExhibition = { ...exhibition, stand: stand };

      setExhibitionForDelete(previewExhibition);
      setStandInfo({
        id: stand.id,
        statsCountCompany: item.statsCountCompany,
        statsConfirmedMeetings: item.statsConfirmedMeetings,
        statsUnconfirmedMeetings: item.statsUnconfirmedMeetings
      });
    } else if (!isAdmin && !isArchive) {
      const isThereUnCorfirmedMeetings = stand.statsUnconfirmedMeetings > 0;
      const isThereCorfirmedMeetings = stand.statsConfirmedMeetings > 0;
      const previewExhibition = { ...exhibition, stand: stand };

      setExhibitionForDelete(previewExhibition);
      if (!isThereUnCorfirmedMeetings && !isThereCorfirmedMeetings) {
        handleOpenModal("DELETE_MODE_V2");
      } else if (isThereUnCorfirmedMeetings || isThereCorfirmedMeetings) {
        handleOpenModal("DELETE_MODE_V1");
      }
    } else if (isArchive) {
      handleOpenModal(`DELETE_MODE_${exhibition.exhibitionName}`);
      const previewExhibition = { ...exhibition, stand: stand };

      setExhibitionForDelete(previewExhibition);
      setStandInfo(stand.id);
    }
  };

  const getSummaryStatus = (isTooltip = false) => {
    const exhibitionStatus = item.moderationStatusId;
    if (exhibitionStatus === 4 || pathname.includes("/admin-panel/edit-and-view-exhibition")) {
      if (isTooltip) {
        return moderationStatusObject[item.moderationStatusId];
      } else {
        return item.moderationStatus?.localizedName?.[lang];
      }
    } else {
      if (isTooltip) {
        return moderationStatusObject[item.stands[0].moderationStatusId];
      } else {
        return item.stands[0].moderationStatus?.localizedName?.[lang];
      }
    }
  };

  const getStatusColor = (statusId) => {
    const exhibitionStatus = item.moderationStatusId;
    const isEditing = isEditMode && editExhibitionId === item.id && item.moderationStatusId !== 5;

    if (exhibitionStatus === 4) {
      return statusColor[4];
    } else if (
      isEditing ||
      (!pathname.includes("edit-and-view-exhibition") && isEditMode && isExhibitionEditable)
    ) {
      return statusColor[2];
    } else {
      return statusColor[statusId];
    }
  };

  const normalizeExhibitionData = ({
    exhibition,
    stand,
    boothNumber,
    description,
    website,
    areaName,
    exhibitionName,
    cityId,
    ...rest
  }) => {
    console.log(exhibition, "exhibition");
    const startDate = exhibition.startDate[0];
    const endDate = exhibition.startDate[1];
    const date1 = dayjs(startDate);
    const date2 = dayjs(endDate);
    const daysCount = date2.diff(date1, "day");

    const extractedRangePickerArray = [];
    for (const key in rest) {
      if (key.includes("rangePicker")) {
        extractedRangePickerArray.push(rest[key]);
      }
    }

    function formatTime(date) {
      return dayjs(date.$d).format("HH:mm");
    }

    const formattedTimeArray = extractedRangePickerArray.map((nestedArray) => {
      const startTime = formatTime(nestedArray[0]);
      const endTime = formatTime(nestedArray[1]);
      return { startTime, endTime };
    });

    const workingHours = Array.from({ length: daysCount + 1 }, (_, i) => {
      return {
        startDate: date1.add(i, "day").format("DD.MM.YYYY"),
        timeRange: formattedTimeArray
      };
    });

    const newObj = {
      exhibitionName,
      website: website,
      countryId: exhibition.countryId,
      cityId: cityId,
      id: exhibition.id,
      logo: logo || exhibition?.logo,
      areaName: areaName,
      startDate: dayjs(exhibition.startDate[0].$d).format("DD-MM-YYYY"),
      endDate: dayjs(exhibition.startDate[1].$d).format("DD-MM-YYYY"),
      times: workingHours,
      isPrivate: isAdmin ? item.isPrivate : checkBoxSelected.isPrivate,
      stand: {
        isVisible: checkBoxSelected.isVisible,
        passageDiagram: passageDiagram ? passageDiagram : stand?.passageDiagram,
        boothNumber: boothNumber,
        description: description
      }
    };
    return newObj;
  };

  const onModerationClick = () => {
    const sendData = form.getFieldsValue();
    const normalizedData = normalizeExhibitionData(sendData);
    if (isEditMode && isAdmin) {
      form.validateFields().then(() => {
        navigate(
          `/company-profile/${item.creatorId}/exhibition/${editExhibitionId}${
            editStandId ? `?standId=${editStandId}` : ""
          }`,
          {
            state: {
              fromAdminSendStand: isAdmin && pathname.includes("/admin-panel/users-list"),
              isFromAdmin: true,
              exhibitionId: editExhibitionId,
              standId: editStandId,
              exhibitionData: sendData,
              passageDiagram: passageDiagram,
              logo: isLogoDeleted ? "" : logo || item?.logo,
              standDescription: stand?.description,
              exhibitionDescription: sendData?.description,
              isPrivate: checkBoxSelected?.isPrivate,
              isVisible: checkBoxSelected?.isVisible,
              isImageDeleted: isImageDeleted,
              isNew: item?.isNew,
              item,
              isUserExhibition: isUserExhibition
            }
          }
        );
      });
    } else if (!isEditMode && isAdmin) {
      return false;
    }

    if (isEditMode && !isAdmin) {
      console.log("2");
      form
        .validateFields()
        .then(() => {
          const data = normalizeExhibitionData(sendData);
          const formValues = form.getFieldsValue();
          navigate("/account/exhibition-preview", {
            state: {
              exhibition: { ...data },
              isPrivate: checkBoxSelected.isPrivate,
              isVisible: checkBoxSelected.isVisible,
              isNewExhibition: false,
              editStandId: editStandId,
              editExhibitionId: editExhibitionId,
              passageDiagram: isImageDeleted ? null : passageDiagram,
              standDescription: stand?.description,
              exhibitionDescription: item?.description,
              isImageDeleted: isImageDeleted,
              item: item,
              formValues: { ...formValues, passageDiagram, logo },
              isUserExhibition: isUserExhibition,
              type: "exists"
            }
          });
        })
        .catch(({ errorFields }) => form.submit());
    } else if (!isAdmin && !isEditMode) {
      return false;
    }
  };

  const onCountryChange = () => {
    form.setFieldsValue({ cityId: undefined });
  };

  const { OnlyLatinLettersTextInput, OnlyLatinLettersModal } =
    useOnlyLatinLetterInputHandlerAndModal();

  return (
    <Form
      labelAlign="left"
      form={form}
      key={item.id}
      onFinish={(values) => onFinish(values,times)}
      onFinishFailed={({ errorFields }) =>
        item.id === editExhibitionId && handleErrors(errorFields)
      }
      scrollToFirstError={{
        block: "center",
        behavior: "smooth"
      }}
      onClick={() => setCurrentItem(item)}
      name={`edtiExhibitionFormTable`}
      autoComplete="off"
      requiredMark={false}
      validateTrigger={"onSubmit"}
      initialValues={{
        ...exhibitionInitialValues
      }}
      style={{ width: "max-content" }}
    >
      {OnlyLatinLettersModal}
      <div className={s.tableRow}>
        <div className={s.head}>
          {isAdmin ? (
            <div className={`${s.cell} ${s.leftSide}`} style={{ width: 90 }}>
              {t("table.creator")}
              {isFirstElement && (
                <Sorter handleSort={handleSort} name={"creator"} id={item.id} sorting={sorting} />
              )}
            </div>
          ) : (
            <div className={`${s.cell} ${s.num} ${s.leftSide}`}>{item?.num}</div>
          )}
          <div className={`${s.cell} ${s.premid}`}>
            {t("table.exhibitionName")}
            {isAdmin && isFirstElement && (
              <Sorter handleSort={handleSort} name={"exhibitionName"} sorting={sorting} />
            )}
          </div>
          <div className={`${s.cell} ${s.premid}`}>{t("table.website")}</div>
          <div className={`${s.cell} ${isAdmin ? s.mid : s.big2}`}>
            {t("table.countryAndCity")}
            {isAdmin && isFirstElement && (
              <Sorter handleSort={handleSort} name={"country"} sorting={sorting} />
            )}
          </div>
          <div className={`${s.cell} ${s.premid}`}>{t("table.areaName")}</div>
          <div className={`${s.cell} ${s.big} ${s.halfPadding}`}>
            {t("table.startAndEndDate")}
            {isAdmin && isFirstElement && (
              <Sorter handleSort={handleSort} name={"startDate"} sorting={sorting} />
            )}
          </div>
          <div
            className={`${s.cell} ${s.mid2}`}
            style={{ width: 130 /* isEditMode || exhibitionPanel ? 300 : 151 */ }}
          >
            {t("table.times")}
          </div>
          <div
            className={`${s.cell} ${s.premid} ${s.companies}`}
            style={{ width: 83, wordBreak: "break-word", padding: "5px 8px" }}
          >
            <p>
              {isAdmin ? t("table.companies1") : t("table.meetings1")}
              {isAdmin && isFirstElement && (
                <Sorter handleSort={handleSort} name={"statsCountCompany"} sorting={sorting} />
              )}
            </p>
            <p>
              {isAdmin ? t("table.companies2") : t("table.meetings2")}
              {isAdmin && isFirstElement && (
                <Sorter
                  handleSort={handleSort}
                  name={"statsUnconfirmedMeetings"}
                  sorting={sorting}
                />
              )}
            </p>
            {isAdmin && (
              <p>
                {t("table.companies3")}
                {isAdmin && isFirstElement && (
                  <Sorter
                    handleSort={handleSort}
                    name={"statsConfirmedMeetings"}
                    sorting={sorting}
                  />
                )}
              </p>
            )}
          </div>
          <div className={`${s.cell} ${s.premid}`} style={{ width: 100 }}>
            {t("table.moderationStatus")}
          </div>
          {isAdmin && (
            <div className={`${s.cell} ${s.premid}`} style={{ width: isAdmin ? 110 : 100 }}>
              {t("table.updatedAt")}
              {isFirstElement && (
                <Sorter handleSort={handleSort} name={"updatedAt"} sorting={sorting} />
              )}
            </div>
          )}
        </div>
        <div className={s.tableBody}>
          {!isAdmin && <div className={`${s.cell2} ${s.leftSide}`}></div>}
          {isAdmin && (
            <div className={`${s.cell2} ${s.premid}`}>
              <Link
                to={`/company-profile/${item.creatorId}`}
                className={s.link}
                style={{
                  pointerEvents: item.creatorType === "company" ? "all" : "none",
                  color: item.creatorType === "admin" && "black"
                }}
              >
                {item.creatorType === "company"
                  ? item?.creator.companyName
                  : `${item?.creator.firstName} ${item?.creator.lastName}`}
              </Link>
            </div>
          )}
          <div className={`${s.cell2} ${s.premid}`}>
            <EditOrViewCell
              editExhibitionId={editExhibitionId}
              editStandId={editStandId}
              isDisabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
              exhibitionId={item.id}
              defaultValue={item?.exhibitionName}
              form={form}
              standId={"head"}
              placeholder={t("placeholder", { ns: "CreateExhibitionPanel" })}
              view={
                <Link
                  className={s.link}
                  to={`/company-profile/${item.creatorId}/exhibition/${item.id}`}
                  target="_blank"
                  style={{
                    wordBreak: "break-all"
                  }}
                >
                  {item?.exhibitionName}
                </Link>
              }
              editingType={"text"}
              formItemName={"exhibitionName"}
              OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
            />
          </div>
          <div className={`${s.cell2} ${s.premid}`} style={{ wordBreak: "break-word" }}>
            <EditOrViewCell
              editExhibitionId={editExhibitionId}
              isDisabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
              editStandId={editStandId}
              defaultValue={item?.website}
              exhibitionId={item.id}
              form={form}
              rules={[
                {
                  required: true,
                  message: t("websiteFillingError", { ns: "FS8-changeCompanyProfile" })
                },
                {
                  validator: (_, value) => {
                    const httpPattern = /^https?:\/\//;
                    const urlPattern =
                      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?(#.*)?$/;
                    if (!value || !httpPattern.test(value)) {
                      return Promise.reject(t("websiteError", { ns: "FS8-changeCompanyProfile" }));
                    }
                    if (!value || !urlPattern.test(value)) {
                      return Promise.reject(
                        t("webSiteUnCorrected", { ns: "FS8-changeCompanyProfile" })
                      );
                    } else {
                      return Promise.resolve();
                    }
                  }
                }
              ]}
              standId={"head"}
              placeholder={t("addExhibitionLink", { ns: "CreateExhibitionPanel" })}
              view={
                <a className={s.link} href={`${item?.website}`} target="_blank" rel="noreferrer">
                  {item?.website}
                </a>
              }
              editingType={"text"}
              formItemName={"website"}
              OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
            />
          </div>
          <div className={`${s.cell2} ${isAdmin ? s.mid : s.big2} ${s.tableColumn}`}>
            <EditOrViewCell
              editExhibitionId={editExhibitionId}
              isDisabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
              editStandId={editStandId}
              form={form}
              exhibitionId={item.id}
              onCountryChange={onCountryChange}
              defaultValue={item?.countryId}
              standId={"head"}
              view={<p>{item?.country?.localizedName[lang]}</p>}
              editingType={"COUNTRY_SELECT"}
              formItemName={["exhibition", "countryId"]}
              placeholder={t("selectCountry", { ns: "CreateExhibitionPanel" })}
              OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
            />
            <EditOrViewCell
              editExhibitionId={editExhibitionId}
              isDisabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
              editStandId={editStandId}
              exhibitionId={item.id}
              defaultValue={{ city: item?.cityId, country: allValues?.exhibition?.countryId }}
              standId={"head"}
              form={form}
              view={
                <p style={{ wordBreak: "break-all" }}>
                  {item?.city?.localizedName?.[lang] || item?.city}
                </p>
              }
              editingType={"CITY_SELECT"}
              formItemName={"cityId"}
              placeholder={t("entercity", { ns: "CreateExhibitionPanel" })}
              OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
            />
          </div>
          <div className={`${s.cell2} ${s.premid}`}>
            <EditOrViewCell
              editExhibitionId={editExhibitionId}
              isDisabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
              editStandId={editStandId}
              exhibitionId={item.id}
              standId={"head"}
              form={form}
              defaultValue={item?.areaName}
              view={<p style={{ wordBreak: "break-all" }}>{item?.areaName}</p>}
              editingType={"text"}
              formItemName={"areaName"}
              placeholder={t("enterAreaName", { ns: "CreateExhibitionPanel" })}
              OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
            />
          </div>
          <div className={`${s.cell2} ${s.big} ${s.halfPaddingCell2}`}>
            {isExhibitionEditable && isEditMode ? (
              <Form.Item
                name={["exhibition", "startDate"]}
                rules={[
                  {
                    required: true,
                    message: ""
                  }
                ]}
              >
                <RangePicker
                  className={s.datePicker}
                  disabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
                  onChange={onStartDateChange}
                  format={"DD.MM.YYYY"}
                  placement="bottomRight"
                  showToday={false}
                />
              </Form.Item>
            ) : (
              <p className={s.cellContent}>
                {dayjs(item?.startDate).format("DD.MM.YYYY")} {" - "}
                {dayjs(item?.endDate).format("DD.MM.YYYY")}
              </p>
            )}
          </div>
          {/* <div className={`${s.cell2} ${s.premid2} ${s.halfPaddingCell2}`}>
            {isExhibitionEditable && isEditMode ? (
              <Form.Item
                name={["exhibition", "startDate"]}
                rules={[
                  {
                    required: true,
                    message: ""
                  }
                ]}
              >
                <DatePicker
                  className={s.datePicker}
                  disabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
                  onChange={onStartDateChange}
                  format={"DD.MM.YYYY"}
                  placement="bottomRight"
                  showToday={false}
                  disabledDate={(current) =>
                    (times.endDate && current > dayjs(times.endDate).endOf("day")) ||
                    (current && current < dayjs().startOf("day"))
                  }
                />
              </Form.Item>
            ) : (
              <p className={s.cellContent}>{dayjs(item?.startDate).format("DD.MM.YYYY")}</p>
            )}
          </div> */}
          {/* <div className={`${s.cell2} ${s.premid2} ${s.halfPaddingCell2}`}>
            {isExhibitionEditable && isEditMode ? (
              <Form.Item
                name={["exhibition", "endDate"]}
                rules={[
                  {
                    required: true,
                    message: ""
                  }
                ]}
              >
                <DatePicker
                  className={s.datePicker}
                  onChange={onEndDateChange}
                  disabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
                  format={"DD.MM.YYYY"}
                  placement="bottomRight"
                  showToday={false}
                  disabledDate={(current) => {
                    return (
                      (current &&
                        times.startDate &&
                        current < dayjs(times.startDate).startOf("day")) ||
                      (current && current < dayjs().startOf("day"))
                    );
                  }}
                />
              </Form.Item>
            ) : (
              <p className={s.cellContent}>{dayjs(item?.endDate).format("DD.MM.YYYY")}</p>
            )}
          </div> */}
          <div
            className={`${s.cell2} ${s.mid2} ${s.halfPaddingCell2}`}
            style={{ width: 130 /* isEditMode || exhibitionPanel ? 300 : 151 */ }}
          >
            {times.times
              .sort((a, b) => a.id - b.id)
              ?.map((el, i) => {
                if (!isArchive) {
                  form.setFieldsValue({
                    [`rangePicker_${i}`]: [
                      dayjs(
                        dayjs(el.startDate?.$d || el.startDate).format(
                          `YYYY-MM-DD ${el.startTime || "10:00"}`
                        )
                      ),
                      dayjs(
                        dayjs(el.startDate?.$d || el.startDate).format(
                          `YYYY-MM-DD ${el.endTime || "18:00"}`
                        )
                      )
                    ]
                  });
                }
                return isEditMode && isExhibitionEditable ? (
                  <Form.Item
                    name={`rangePicker_${i}`}
                    key={`${i}_`}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <div className="d-flex align-items-center" style={{ width: 125 }}>
                      {el.date}:
                      <TimePicker.RangePicker
                        className={s.datePicker}
                        format={"HH:mm"}
                        placeholder={[t("startTime"), t("endTime")]}
                        style={{ marginLeft: "5px" }}
                        disabled={(!isAdmin && !isUserExhibition) || editOnlyStand}
                        minuteStep={5}
                        defaultValue={[
                          dayjs(
                            dayjs(el.startDate?.$d || el.startDate).format(
                              `YYYY-MM-DD ${el.startTime || "10:00"}`
                            )
                          ),
                          dayjs(
                            dayjs(el.endDate?.$d || el.endDate).format(
                              `YYYY-MM-DD ${el.endTime || "18:00"}`
                            )
                          )
                        ]}
                        value={[el.timeRange[0], el.timeRange[1]]}
                        onCalendarChange={(val) => {
                          form.setFieldsValue({[`rangePicker_${i}`]: val});
                          onWorkingTimeChange(val, i);
                        }}
                      />
                    </div>
                  </Form.Item>
                ) : (
                  <p key={el.id}>
                    {el.date}-{el.startTime}:{el.endTime}
                  </p>
                );
              })}
          </div>
          <div className={`${s.cell2} ${s.big}`} style={{ width: 83 }}>
            {!isAdmin ? (
              <p className={s.cellContent}>
                {item.stands[0].statsUnconfirmedMeetings}/{item.stands[0].statsConfirmedMeetings}
              </p>
            ) : (
              <p className={s.cellContent}>
                {item?.statsCountCompany}/{item?.statsUnconfirmedMeetings}/
                {item?.statsConfirmedMeetings}
              </p>
            )}
          </div>
          <div
            className={`${s.cell2} ${s.big}`}
            style={{
              paddingLeft: !isAdmin && lang === "en" ? 10 : 16,
              width: 100,
              wordBreak: "break-word"
            }}
          >
            <Space>
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <p
                  style={
                    !isArchive
                      ? {
                          color:
                            !isAdmin &&
                            isEditMode &&
                            editExhibitionId === item.id &&
                            item.moderationStatusId !== 5
                              ? "black"
                              : getStatusColor(
                                  pathname.includes("/admin-panel/edit-and-view-exhibition")
                                    ? item.moderationStatusId
                                    : item?.stands?.[0]?.moderationStatusId
                                ),
                          width: "100%"
                        }
                      : {}
                  }
                >
                  {isEditMode && editExhibitionId === item.id && item.moderationStatusId !== 5
                    ? t("edititingProccessStatus")
                    : getSummaryStatus()}
                  <Tooltip
                    placement="bottomLeft"
                    title={
                      isEditMode && editExhibitionId === item.id && item.moderationStatusId !== 5
                        ? moderationStatusObject[2]
                        : getSummaryStatus(true)
                    }
                  >
                    <QuestionCircleOutlined
                      style={{
                        position: "relative",
                        cursor: "help",
                        alignSelf: "end",
                        marginBottom: 5,
                        marginLeft: 5,
                        color: "#474747"
                      }}
                    />
                  </Tooltip>
                </p>
              </div>
            </Space>
          </div>
          {isAdmin && (
            <div
              className={`${s.cell2} ${s.big}`}
              style={{ width: 100, paddingLeft: 16, wordBreak: "break-word" }}
            >
              {convertDate(item.updatedAt)} {convertTime(item.updatedAt)}
              {item?.edit && <p>{item.edit?.email}</p>}
            </div>
          )}
        </div>
        {!isAdmin || pathname.includes("/admin-panel/users-list") ? (
          item.stands?.map((stand) => (
            <SecondaryTableRow
              stand={stand}
              isOnlyExhibition={false}
              key={Item.id}
              OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
              item={item}
              t={t}
              onModerationClick={onModerationClick}
              checkBoxSelected={checkBoxSelected}
              setCheckboxSelected={setCheckboxSelected}
              form={form}
              errors={errors}
              setErrors={setErrors}
              setIsImageDeleted={setIsImageDeleted}
              isImageDeleted={isImageDeleted}
              passageDiagram={passageDiagram}
              handleDelete={handleDelete}
              setPassageDiagram={setPassageDiagram}
              logo={logo}
              onFinish={onFinish}
              editindExhibition={editindExhibition}
              setLogo={setLogo}
              setIsLogoDeleted={setIsLogoDeleted}
              isLogoDeleted={isLogoDeleted}
              handleOpenModal={handleOpenModal}
              clearImage={clearImage}
              isStandEditable={editStandId === stand.id}
              handleEdit={handleEdit}
              isUserExhibition={isUserExhibition}
              isArchive={isArchive}
            />
          ))
        ) : (
          <SecondaryTableRow
            isOnlyExhibition={isAdmin}
            key={Item.id}
            OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
            item={item}
            logo={logo}
            setLogo={setLogo}
            setIsLogoDeleted={setIsLogoDeleted}
            isLogoDeleted={isLogoDeleted}
            setErrors={setErrors}
            onModerationClick={onModerationClick}
            checkBoxSelected={checkBoxSelected}
            setCheckboxSelected={setCheckboxSelected}
            errors={errors}
            editindExhibition={editindExhibition}
            t={t}
            onFinish={onFinish}
            form={form}
            handleDelete={handleDelete}
            handleOpenModal={handleOpenModal}
            handleEdit={handleEdit}
            isUserExhibition={isUserExhibition}
            isArchive={isArchive}
          />
        )}
        {isEditMode && editExhibitionId === item.id && (
          <Row align="center" className={s.actions}>
            <Button
              className={`${s.actionBtn} ${s.save} ${!isEditIconShow ? s.disabled : ""} btn btn_v2`}
              type={"submit"}
              htmlType="submit"
              disabled={!isEditIconShow}
            >
              {t("saveAndContinueEditing", { ns: "FS100-MyExhibitions" })}
            </Button>
            <Button
              type="default"
              onClick={() => onModerationClick()}
              className={`${s.actionBtn} btn btn_v8 ant-btn-lg`}
            >
              {t("preview", { ns: "FS100-MyExhibitions" })}
            </Button>
          </Row>
        )}
      </div>
    </Form>
  );
};

export default ExhibitionTableRow;
